var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuizMarkWords(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#8F8F8F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    d: "M1.405 4.021h6.736M8.929 4.021h1.877M11.594 4.021h4.366M16.753 4.021h5.842M1.405 18.757h4.929M7.233 18.757H12M18.079 18.757h4.516M1.405 13.845h6.736M16.753 13.845h5.842"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4DBF7A",
    stroke: "#379954",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M15.714 14.852H9.179a.25.25 0 0 1-.25-.25v-1.515a.25.25 0 0 1 .25-.25h6.535a.25.25 0 0 1 .25.25v1.515a.25.25 0 0 1-.25.25z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#8F8F8F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    d: "M1.405 8.933h1.877M15.308 8.933h7.287M11.594 8.933h2.921"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#4DBF7A",
    stroke: "#379954",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M10.517 9.94H4.359a.25.25 0 0 1-.25-.25V8.175a.25.25 0 0 1 .25-.25h6.157a.25.25 0 0 1 .25.25V9.69c.001.138-.111.25-.249.25z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M16.858 18.01h-1.649l1.145 2.73-.916.384-1.145-2.73-1.238 1.226v-5.398z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizMarkWords);
export default __webpack_public_path__ + "static/media/quiz_markWords.676274eac6de0ee883384ccc8a065d26.svg";
export { ForwardRef as ReactComponent };